import './index.scss'
// import '../../assets/scripts/myNiceScroll'
// import {resizeScroll} from '../../assets/scripts/myNiceScroll'

$(document).scroll(function () {
  var scroH = $(document).scrollTop(); //滚动高度
  $('.section1 .bg-img b').css('transform','translateY('+ scroH / 4 +'px)')
});


$(document).scroll(function () {
  let scroH = $(document).scrollTop(); //滚动高度
  let viewH = $(window).height(); //可见高度
  let contentH = $(document).height(); //内容高度

  let fixedTop = $('.section2 .cont .article').offset().top - 150
  let fixedBtm = $('.section2 .cont .article').offset().top + $('.section2 .cont .article').outerHeight() - $('.section2 .fixed-title').outerHeight() - 150

  if($(window).width() > 1024){
    if (scroH < fixedTop) {
      $('.section2 .fixed-title').removeClass('fixed')
    }else if (scroH > fixedTop && scroH < fixedBtm) {
      $('.section2 .fixed-title').addClass('fixed').removeClass('abs')
    }else{
      $('.section2 .fixed-title').addClass('abs').removeClass('fixed')
    }
  }
});

$(document).ready(function(){
  $('.article img').each(function(index,value){
    if($(this).width() > 200){
      $(this).addClass('block')
    }
  })
})